// The navigation contract of 04 §Global chrome, in one place.
//
// Every screen the app will ever have is listed here from the start, including the ones that are
// not built yet. Two reasons: the owner can see the shape of the product rather than discovering
// screens as they appear, and a route that is not built says so plainly instead of 404-ing or —
// worse — rendering an empty page that looks like a bug.
//
// `built: false` is a promise about the roadmap, not a placeholder to forget about. When a screen
// lands, one flag flips.

export interface RouteSpec {
  path: string;
  labelBg: string;
  labelEn: string;
  built: boolean;
  /** Which work package brings it, so the "not yet" screen can say something useful. */
  wp: string;
}

export const ROUTES: readonly RouteSpec[] = [
  { path: '/', labelBg: 'Днес', labelEn: 'Today', built: true, wp: 'B6' },
  { path: '/leads', labelBg: 'Потенциални', labelEn: 'Leads', built: true, wp: 'B5' },
  { path: '/kanban', labelBg: 'Канбан', labelEn: 'Kanban', built: true, wp: 'B5' },
  { path: '/map', labelBg: 'Карта', labelEn: 'Map', built: true, wp: 'B5' },
  { path: '/clients', labelBg: 'Клиенти', labelEn: 'Clients', built: true, wp: 'C5' },
  { path: '/pipeline', labelBg: 'Пайплайн', labelEn: 'Pipeline', built: true, wp: 'B7' },
  { path: '/logs', labelBg: 'Логове', labelEn: 'Logs', built: true, wp: 'B8' },
  { path: '/admin', labelBg: 'Админ', labelEn: 'Admin', built: true, wp: 'B7' },
];

export function routeFor(path: string): RouteSpec | undefined {
  return ROUTES.find((route) => route.path === path);
}
